import { Helmet } from "react-helmet";
import React, { Suspense, lazy, useState, useEffect, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";


export function AdminUser({ account }) {
  let { userId } = useParams();

  const [userEvents, setUserEvents] = useState([]);
  const endTrial = async (userId) => {
    try {
      let response = await fetch("/api/admin/users", {
        method: 'PATCH',
        cache: 'no-cache',
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
          user_id: userId,
          plan_type: "FREE"
        })
      });
      let data = await response.json();
    } catch(error) {
      console.log(error);
    }
  }

  useEffect(() => {
    const runFetch = async () => {
      let response = await fetch(`/api/admin/events/${userId}`, {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
      });
      let data = await response.json();
      setUserEvents(data);
    };
    runFetch();
  }, []);

  const countEvent = (name) => {
    return userEvents.filter((data) => data.name === name).length;
  };

  return (
    <div>
      <Helmet>
        <title>ClosetWitch - Admin user</title>
        <meta name="description" content="Sell on Poshmark? Cast Productivity Spells on Your Closet with ClosetWitch"></meta>
      </Helmet>
      <section className="section">
        <div className="container">
          <h1 className="title">ID: { userId }</h1>
            <div className="columns">
              <div className="column is-one-third">
              <div className="card">
              <div className="card-content">
                <div className="content">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Event Type</th>
                          <th>Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Share</td>
                          <td>{countEvent("share")}</td>
                        </tr>
                        <tr>
                          <td>Send offers</td>
                          <td>{countEvent("send_offers")}</td>
                        </tr>
                        <tr>
                          <td>Update prices</td>
                          <td>{countEvent("update_prices")}</td>
                        </tr>
                        <tr>
                          <td>Relist</td>
                          <td>{countEvent("relist_item_success")}</td>
                        </tr>
                        <tr>
                          <td>Comping</td>
                          <td>{countEvent("comp")}</td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <table className="table">
            <thead>
            <tr>
              <th>Event</th>
              <th>Date</th>
              <th>Props</th>
            </tr>
          </thead>
          <tbody>
            { 
              userEvents.map((event) => {
                return (
                  <tr>
                    <td>{event.name}</td>
                    <td>{event.props.datetime}</td>
                    <td>{JSON.stringify(event.props)}</td>
                  </tr>
                );
              })
            }
          </tbody>
          </table>
          <button className="button is-primary" onClick={() => endTrial(userId) }>End Trial</button>
        </div>
      </section>
    </div>
  );
}

function Admin({ admin }) {
  const [adminData, setAdminData] = useState([]);

  useEffect(() => { 
    const fetchData = async () => {
      try {
        let response = await fetch("/api/admin/users", {
          method: 'GET',
          cache: 'no-cache',
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        });
        let data = await response.json();
        setAdminData(data);
      } catch(error) {
        console.log(error);
      }
    }
    fetchData();
  }, []);

  const [orderData, setOrderData] = useState({});
  const ths = (label, sortby) => {
    return (
      <th onClick={() => {
        let newOrderData = {...orderData};
        const order = orderData[sortby];
        const newData = [...adminData].sort((a, b) => {
          const x = a[sortby] || "";
          const y = b[sortby] || "";
          if (order) {
             if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          } else {
            if (x < y) {
              return 1;
            }
            if (x > y) {
              return -1;
            }
            return 0;
          }
          return (order ? x > y : x < y);
        });   
        setOrderData(newOrderData);
        setAdminData(newData);
        newOrderData[sortby] = !orderData[sortby];
      }
      }>{label}</th>
    );
  };
  const showUserInfo = async (userId) => {
    try {
      let response = await fetch("/api/admin/events/" + userId, {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include"
      });
      let data = await response.json();
      console.log(data);
    } catch(error) {
      console.log(error);
    }
  }

  const isVerified = (user) => { 
    return user.poshmark_id?.length > 0;
  }

  return (
    <div>
      <Helmet>
        <title>ClosetWitch</title>
        <meta name="description" content="Sell on Poshmark? Cast Productivity Spells on Your Closet with ClosetWitch"></meta>
      </Helmet>
      <section className="section pricing-section">
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Profile</th>
                {ths("Email", "email")}
                {ths("Plan", "plan_type")}
                {ths("Poshmark ID", "poshmark_id")}
                <th>Stripe ID</th>
                {ths("Subscription Status", "stripe_subscription_status")}
                <th>Promo</th>
                {ths("Trial Expires", "trial_end_at")}
                {ths("Trial Ended", "trial_ended_on")}
                {ths("Activity Count", "activity_count")}
                {ths("Last Active", "last_active")}
              </tr>
            </thead>
            <tbody>
              { 
                adminData.map((user) => {
                  return (
                    <tr key={user.id} className={isVerified(user) ? "verified" : ""}>
                      <td>
                        <Link target="_blank" to={`/admin/user/${user.id}`}>
                          <button className="button"> 
                            <span className="icon is-small">
                            <FontAwesomeIcon icon={faUser} />
                            </span>
                          </button>
                        </Link>
                      </td>
                      <td>{user.email}</td>
                      <td>{user.plan_type}</td>
                      <td><a href={`https://poshmark.com/closet/${user.poshmark_id}`} target="_blank">{user.poshmark_id}</a></td>
                      <td>{user.stripe_customer_id}</td>
                      <td>{user.stripe_subscription_status}</td>
                      <td>{user.promo_code}</td>
                      <td>{user.trial_end_at}</td>
                      <td>{user.trial_ended_on}</td>
                      <td>{user.activity_count}</td>
                      <td>{user.last_active}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export default Admin;
